import Stores from './Stores';

export default Stores;



// WEBPACK FOOTER //
// ./src/pages/Stores/index.ts